export default "__VITE_ASSET__1e247114__"